import React from 'react'
import { classNames } from '@react-pdf-viewer/core';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function VolunteerHomeView() {
  const navigate = useNavigate()
  return (
    <div>
      <h2>Volunteer Scientist</h2>
      <p>Content coming soon for volunteer scintist.....</p>
      <Button type="primary" onClick={()=>navigate('/')}>Back Home</Button>
    </div>
  )
}
